import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7bd47c90"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bd47c90')) {
      api.createRecord('7bd47c90', component.options)
    } else {
      api.reload('7bd47c90', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7bd47c90", function () {
      api.rerender('7bd47c90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/feedback/index.vue"
export default component.exports